export type QualityLevel = 'low' | 'medium' | 'high' | 'ultra';

export interface QualitySettings {
  level: QualityLevel;
  maxDpr: number;
  renderScale: number;
  msaa: number;
  shadowSize: number;
  cascades: number;
  terrainGrid: number;
  terrainRange: number;
  treeDensity: number;
  treeMeshDistance: number;
  impostorDistance: number;
  hoodooLod: [number, number];
  hoodooMaxDist: number;
  cloudScale: number;
  cloudSteps: number;
  grass: boolean;
  bloom: number;
}

export const QUALITY: Record<QualityLevel, QualitySettings> = {
  low: {
    level: 'low', maxDpr: 1.25, renderScale: 0.85, msaa: 0, shadowSize: 1024, cascades: 2, terrainGrid: 32, terrainRange: 80,
    treeDensity: 0.4, treeMeshDistance: 80, impostorDistance: 2200, hoodooLod: [22, 90], hoodooMaxDist: 1200, cloudScale: 0.25, cloudSteps: 32,
    grass: false, bloom: 0.04,
  },
  medium: {
    level: 'medium', maxDpr: 1.25, renderScale: 1, msaa: 2, shadowSize: 2048, cascades: 3, terrainGrid: 64, terrainRange: 110,
    treeDensity: 0.75, treeMeshDistance: 140, impostorDistance: 4500, hoodooLod: [32, 120], hoodooMaxDist: 2000, cloudScale: 0.35, cloudSteps: 48,
    grass: true, bloom: 0.05,
  },
  high: {
    level: 'high', maxDpr: 1.5, renderScale: 1, msaa: 4, shadowSize: 2048, cascades: 4, terrainGrid: 64, terrainRange: 150,
    treeDensity: 1, treeMeshDistance: 200, impostorDistance: 7000, hoodooLod: [45, 170], hoodooMaxDist: 3000, cloudScale: 0.5, cloudSteps: 64,
    grass: true, bloom: 0.05,
  },
  ultra: {
    level: 'ultra', maxDpr: 2, renderScale: 1, msaa: 4, shadowSize: 4096, cascades: 4, terrainGrid: 64, terrainRange: 210,
    treeDensity: 1, treeMeshDistance: 300, impostorDistance: 9000, hoodooLod: [70, 260], hoodooMaxDist: 4000, cloudScale: 0.5, cloudSteps: 96,
    grass: true, bloom: 0.05,
  },
};
